import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import PaceCalc from "../components/PaceCalc";
import TimeCalc from "../components/TimeCalc";
import DistanceCalc from "../components/DistanceCalc";
import "./CalculatorPage.css";

export default function CalculatorPage() {
  useEffect(() => {
    document.title =
      "Running Pace Calculator | Free Training Tools | PaceWerks";
  }, []);

  return (
    <div className="pw-calc-page">
      <header className="pw-calc-header">
        <h1>Free Running Pace, Time, and Distance Calculators</h1>
        <p className="pw-calc-subtitle">
          Three free running calculators built for race training. Calculate your
          pace per mile or kilometer, predict your finish time, or estimate how
          far you ran. No signup required.
        </p>
        <p className="pw-calc-intro">
          Whether you are training for a 5K, half marathon, or marathon, knowing
          your pace is the foundation of smart training. Use these tools
          alongside your PaceWerks training plan to hit your goal race time.
        </p>
      </header>

      <div className="pw-calc-stack">
        <PaceCalc />
        <TimeCalc />
        <DistanceCalc />
      </div>

      <footer className="pw-calc-footer">
        <p className="pw-calc-footer-text">
          Looking for a full training plan? PaceWerks builds free personalized
          running plans from 5K to Marathon based on your race date and goals.{" "}
          <Link className="pw-calc-footer-link" to="/build">
            Build your free training plan
          </Link>
        </p>
      </footer>
    </div>
  );
}
